<template>
  <div class="dialecticalSelect">
    <div class="text-box" @click="showDialog">
      <span v-if="value.length === 0" class="tip">请选择</span>
      <template v-else>
        <span v-for="(item, index) in value" :key="index"
          >{{ item.dialecticName }}<i v-if="item.type == 1">主</i>
        </span>
      </template>
    </div>
    <Modal v-model="showWin" width="800" footer-hide class="dialecticalSelect">
      <template #header>
        <div class="head">
          <span class="title">请选择本次治则的辨证</span>
          <span class="other"
            >（{{
              isOriginPeriod ? "只选一个" : "辨证可多选择, 但只有一个主要辨证"
            }}）</span
          >
        </div>
      </template>
      <div class="group-box">
        <div class="group" v-for="(g_item, index) in groupList" :key="index">
          <div class="group-title">{{ g_item.label }}</div>
          <div class="list">
            <div
              v-for="(item, index) in g_item.list"
              class="item"
              :class="{ active: item.active }"
              @click="onSelect(item)"
              :key="index"
            >
              {{ item.label }}
            </div>
          </div>
        </div>
        <empty
          v-if="groupList.length == 0"
          text="没有症状关联的可选辨证，辨证不用选"
        ></empty>
        <div class="input-box" v-if="!isOriginPeriod">
          <div class="input-title">
            <span class="requare">*</span>
            请从已选辨证中选择一个主要辨证
          </div>
          <Select v-model="dialecticName" transfer>
            <Option
              v-for="(item, index) in dialecticalList"
              :key="index"
              :value="item"
              >{{ item }}</Option
            >
          </Select>
        </div>
      </div>
      <div class="footer" v-if="!isEmpty">
        <Button type="primary" @click="submit">确定</Button>
      </div>
      <Spin fix v-if="isLoading">
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    info: {
      type: Object,
      default: () => ({}),
    },
    selectList: {
      type: Array,
      default: () => [],
    },
    etiologyList: {
      type: Array,
      default: () => [],
    },
    isOriginPeriod: {
      //是否原点期
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      dialecticName: "",
      showWin: false,
      dialecticsList: [],
      groupList: [],
      isEmpty: false,
    };
  },
  computed: {
    dialecticalList() {
      return this.dialecticsList.filter((i) => i.active).map((i) => i.label);
    },
  },
  methods: {
    onSelect(item) {
      if (item.label == this.dialecticName) {
        this.dialecticName = "";
      }
      item.active = !item.active;
      if (this.isOriginPeriod) {
        this.dialecticsList.forEach((i) => {
          if (i.label != item.label) {
            i.active = false;
          }
        });
      }
    },
    submit() {
      if (!this.dialecticalList.length) {
        let s = this.isOriginPeriod ? "一个" : "";
        this.$Message.error(`请选择${s}辨证`);
        return;
      }
      if (!this.dialecticName && !this.isOriginPeriod) {
        this.$Message.error(`请选择一个主要辨证`);
        return;
      }
      let v = this.dialecticalList
        .filter((i) => i != this.dialecticName)
        .map((i, index) => {
          return {
            dialecticName: i,
            type: this.isOriginPeriod ? 0 : 2,
          };
        });
      if (this.dialecticName) {
        v.unshift({
          dialecticName: this.dialecticName,
          type: 1,
        });
      }
      this.$emit("input", v);
      this.showWin = false;
    },
    // 收集部位数据
    getEtiologyReasonList() {
      let arr = [];
      this.etiologyList.forEach((item) => {
        if (item.children.length) {
          arr.push({
            etiologyId: item.value,
            etiologyName: item.label,
            bottomReason: item.children.map((k) => {
              return { reason: k.label, isSelf: k.isSelf === 0 ? 0 : 1 };
            }),
          });
        }
      });
      return arr;
    },

    showDialog() {
      if (!this.selectList.length) {
        this.$Message.error(`请先选择症状`);
        return;
      }
      this.showWin = true;
      this.getData();
    },
    getData() {
      if (this.groupList.length) return;
      this.isLoading = true;
      let obj = {
        keywords: this.selectList.map((i) => i.dsName).join(","),
        hospitalCode: this.info.hospitalCode, //	医馆CODE
        patientCode: this.info.patientCode, //	患者编码
        age: this.info.patientAge, //	年龄
        etiologyReasonList: this.getEtiologyReasonList(),
        saveSymptomType: 1, // "是否为录病例页面 1 是 0 否"
        notErrorTip: true, //	是否不提示错误
      };
      this.api2("symptomDialecticTransSearch", obj)
        .then((res) => {
          this.groupList = this.setWxTableData(res.result.wx);
          if(this.groupList.length){
            this.isEmpty = false;
          }else{
            this.isEmpty = true;
          }
        })
        .catch((err) => {
          this.isEmpty = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    validate() {
      return !this.isEmpty;
    },
    resert() {
      this.isEmpty = false;
    },
    setWxTableData(list) {
      this.dialecticsList = [
        ...new Set(list.map((item) => item.dialecticsName)),
      ].map((item) => {
        return {
          label: item,
          active: false,
        };
      });
      let arr = ["木", "火", "土", "金", "水"].map((key) => {
        return {
          label: key,
          list: list
            .filter((j) => j.name == key)
            .map((j) => {
              return this.dialecticsList.find(
                (i) => i.label == j.dialecticsName
              );
            }),
        };
      });
      return arr.filter((i) => i.list.length);
    },

    setWxTableData2(list) {
      let grouped = list.reduce((acc, item) => {
        let e = acc.find((i) => i.name === item.name);
        if (!e) {
          acc.push({
            name: item.name,
            items: [item],
          });
        } else {
          e.items.push(item);
        }
        return acc;
      }, []);

      // 排序
      grouped.forEach((i) => {
        i.items.sort((a, b) => {
          return a.transOrder ? a.transOrder.localeCompare(b.transOrder) : 0;
        });
      });

      let length = Math.max(...grouped.map((i) => i.items.length));
      let tableDatas = [];
      for (let i = 0; i < length; i++) {
        let obj = { cellClassName: {} };
        grouped.forEach((item) => {
          obj[item.name] = item.items[i]
            ? (item.items[i].transOrder || "") + item.items[i].dialecticsName
            : "";

          let onlyOne = item.items[i] ? item.items[i].onlyOne || "" : ""; //用于标颜色
          obj.cellClassName[item.name] = "only-one_" + onlyOne; //用于标颜色
        });
        tableDatas.push(obj);
      }
      return tableDatas;
    },
  },
};
</script>

<style lang="scss" scoped>
.dialecticalSelect {
  .text-box {
    cursor: pointer;
    .tip {
      color: #ccc;
    }
    span {
      margin-right: 20px;
      i {
        font-style: inherit;
        display: inline-block;
        width: 18px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        background: #f00;
        color: #fff;
        border-radius: 100%;
        font-size: 12px;
      }
    }
  }
  .select-box {
    cursor: pointer;
  }
  .input-title {
    font-weight: bold;
    margin-bottom: 5px;
    .requare {
      color: #f00;
    }
  }
  .group-box {
    min-height: 400px;
  }
  .group {
    margin-bottom: 10px;
    .group-title {
      font-weight: bold;
      margin-bottom: 5px;
    }
    .item {
      display: inline-block;
      border: 1px solid #ccc;
      padding: 2px 15px;
      border-radius: 5px;
      margin: 0 10px 10px 0;
      cursor: pointer;
      background: #fbf7f4;
      &.active {
        background: #96635e;
        color: #fff;
      }
    }
  }
  :deep {
    .empty {
      height: 300px;
    }
    .ivu-modal-content {
      background: #fff;
    }
    .head {
      .title {
        font-weight: bold;
      }
      .other {
        color: #999;
        font-size: 13px;
      }
    }
    .footer {
      border-top: 1px solid #ddd;
      margin: 15px -40px 0 -40px;
      padding-top: 10px;
      text-align: center;
      .ivu-btn {
        width: 160px;
      }
    }
  }
}
</style>